import { render, staticRenderFns } from "./taxation-project-manage.vue?vue&type=template&id=0707e978&"
import script from "./taxation-project-manage.vue?vue&type=script&lang=js&"
export * from "./taxation-project-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports